/** Human-readable file size for download chips and attachment rows. Empty
 * string for a falsy/zero size so callers can hide the label entirely. */
export function formatFileSize(sizeBytes: number | undefined): string {
  if (!sizeBytes) return '';
  if (sizeBytes < 1024) return `${sizeBytes} B`;
  if (sizeBytes < 1024 * 1024) return `${Math.round(sizeBytes / 1024)} KB`;
  return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`;
}
